import * as actions from "../actions/automation";
import update from "immutability-helper";
/**
 * reducer for changes to automation settings
 */
const automationReducer = {
    reducers: {
        [actions.setAutoDeployment]: (state, payload) => update(state, { deploy: { $set: payload } }),
        [actions.setAutoInstall]: (state, payload) => update(state, { install: { $set: payload } }),
        [actions.setAutoEnable]: (state, payload) => update(state, { enable: { $set: payload } }),
        [actions.setAutoStart]: (state, payload) => update(state, { start: { $set: payload } }),
        [actions.setStartMinimized]: (state, payload) => update(state, { minimized: { $set: payload } }),
    },
    defaults: {
        deploy: true,
        install: true,
        enable: true,
        start: false,
        minimized: false,
    },
};
export default automationReducer;
